import { Action, createAction, props } from "@ngrx/store";

export const setActivate = createAction(
	"[ACTIVATE] SET_APP_ACTIVATE",
	props<{ payload: any }>()
);
export const setSimActivate = createAction(
	"[ACTIVATE] SET_APP_SIM_ACTIVATE",
	props<{ activate: any }>()
);
export const resetActivate = createAction("[ACTIVATE] RESET_APP_ACTIVATE");

export const setMobilValidationActivate = createAction(
	"[ACTIVATE] UPDATE_MOBILE_VALIDATION_ACTIVATE",
	props<{ validation: any; simNumber: string }>()
);
export const setMobileCustomerEmail = createAction(
	"[ACTIVATE UPDATE_MOBILE_CUSTOMER_EMAIL",
	props<{ validation: any; email: string }>()
);
